import * as React from "react";
import {useEffect} from "react";
import {URLs} from "@/urls";
import styled from "styled-components";
import {useUTMs} from "@/components/use_utms";

type MCSignupFormProps = {
    buttonText: string;
    formId?: string
    email?: string;
    handleEmailChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    postSuccessRedirectUrl?: string;
    postSuccessJQuery?: string;
};

export function MCSignupForm({
                                 email: extEmail,
                                 handleEmailChange: extHandleEmailChange,
                                 buttonText,
                                 postSuccessJQuery,
                                 postSuccessRedirectUrl,
                                 formId,
                             }: MCSignupFormProps) {
    useUTMs();

    const [email, setEmail] = React.useState(extEmail || '');
    useEffect(() => {
        setEmail(extEmail || '');
    }, [extEmail, setEmail]);
    const _handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!!extHandleEmailChange) {
            extHandleEmailChange(e);
        } else {
            setEmail(e.target.value);
        }
    };

    React.useEffect(() => {
        if (document.getElementById('mc_embed_signup_initialised')) {
            // Already initialised
            return;
        }
        const alreadyInitialised = document.createElement('div');
        alreadyInitialised.id = 'mc_embed_signup_initialised';
        document.body.appendChild(alreadyInitialised);

        // Load Mailchimp validation script
        const script = document.createElement('script');
        script.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js';
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            // First, intercept jQuery AJAX calls before initializing Mailchimp
            const interceptScript = document.createElement('script');
            interceptScript.innerHTML = `
                (function() {
                    // Store the original jQuery ajax method
                    var originalAjax = jQuery.ajax;
                    
                    // Override jQuery.ajax
                    jQuery.ajax = function(options) {
                        // Check if this is a Mailchimp submission
                        if (options.url && options.url.includes('list-manage.com/subscribe/post-json')) {
                            // Store the original success callback
                            var originalSuccess = options.success;
                            
                            // Override the success callback
                            options.success = function(data) {
                                // Call the original success callback first
                                if (originalSuccess) {
                                    originalSuccess.call(this, data);
                                }
                                
                                // Check if submission was successful
                                if (data && data.result === 'success') {
                                    // Get the email from the form
                                    var email = document.getElementById('mce-EMAIL').value;

                                    // Get the UTM params
                                    var utmParams = window?._utms || {source: 'organic', medium: 'website'};
                                    
                                    fetch('${URLs.MAILCHIMP_UPDATE_MEMBER}', {
                                        method: 'POST',
                                        headers: {'Content-Type': 'application/json'},
                                        body: JSON.stringify({
                                            email: email,
                                            mergeFields: {
                                                MMERGE9: utmParams.source,
                                                MMERGE10: utmParams.medium,
                                                MMERGE11: utmParams.campaign || ''
                                            }
                                        })
                                    }).catch(function(err) {
                                        console.error('Failed to update UTMs:', err);
                                    });

                                    ${postSuccessJQuery || ''}

                                    // Add a small delay to ensure Mailchimp's UI updates
                                    setTimeout(function() {
                                        window.location.href = '${postSuccessRedirectUrl || '/?mc_subscribed=true'}';
                                    }, 500);
                                }
                            };
                        }
                        
                        // Call the original ajax method with potentially modified options
                        return originalAjax.call(this, options);
                    };
                })();
            `;
            document.body.appendChild(interceptScript);

            // Now initialize Mailchimp form
            const initScript = document.createElement('script');
            initScript.innerHTML = `
                (function($) {
                    window.fnames = new Array(); 
                    window.ftypes = new Array();
                    fnames[0]='EMAIL';ftypes[0]='email';
                    fnames[1]='FNAME';ftypes[1]='text';
                    fnames[2]='LNAME';ftypes[2]='text';
                    fnames[3]='ADDRESS';ftypes[3]='address';
                    fnames[4]='PHONE';ftypes[4]='phone';
                    fnames[6]='SUBINTENT';ftypes[6]='radio';
                    fnames[5]='USERPLAN';ftypes[5]='dropdown';
                    fnames[7]='MMERGE7';ftypes[7]='dropdown';     
                    fnames[9]='MMERGE9';ftypes[9]='text';
                    fnames[10]='MMERGE10';ftypes[10]='text';
                    fnames[11]='MMERGE11';ftypes[11]='text';          
                }(jQuery));
                var $mcj = jQuery.noConflict(true);
            `;
            document.body.appendChild(initScript);
        };

        return () => {
            // Cleanup scripts on unmount
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, []);

    return <Container id="mc_embed_shell">
        <link href="//cdn-images.mailchimp.com/embedcode/classic-061523.css" rel="stylesheet" type="text/css"/>
        <div id="mc_embed_signup">
            <form
                action={`https://beunbreakable.us10.list-manage.com/subscribe/post?u=241faa8632901abf0f0fea122&amp;id=375c85b106&amp;v_id=${formId || "5775"}&amp;f_id=00f64ae4f0`}
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                className="validate"
                target="_blank"
            >
                <div id="mc_embed_signup_scroll">
                    <div className="indicates-required">
                        <span className="asterisk">*</span> indicates required
                    </div>
                    <div className="mc-field-group">
                        <label htmlFor="mce-EMAIL">
                            Email <span className="asterisk">*</span>
                        </label>
                        <input
                            type="email"
                            name="EMAIL"
                            className="required email"
                            id="mce-EMAIL"
                            required
                            value={email}
                            onChange={_handleEmailChange}
                        />
                    </div>
                    {/*<div className="py-3 mr-2 sm:mr-5 text-primary-100 rounded-lg max-w-2xl" role="alert">*/}
                    {/*    <span className="block font-semibold mb-2 text-primary">Important!</span> To ensure you get your rewards, please use the email address you would use for logging in to the app and any future subscriptions or payments*/}
                    {/*</div>*/}
                    <div id="mergeRow-gdpr" className="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group">
                        <div className="content__gdpr">
                            <label className={"font-bold text-primary"}>Marketing Permissions</label>
                            <p className={"my-2"}>Please confirm that you are giving us permission to email you with the info and updates you are requesting:</p>
                            <fieldset className="mc_fieldset gdprRequired mc-field-group" name="interestgroup_field">
                                <label className="checkbox subfield" htmlFor="gdpr60696">
                                    <input
                                        type="checkbox"
                                        id="gdpr_60696"
                                        name="gdpr[60696]"
                                        className="gdpr"
                                        value="Y"
                                    />
                                    <span>Email</span>
                                </label>
                            </fieldset>
                            <p className={"mt-2"}>You can unsubscribe at any time by clicking the link in the footer of our emails. For information about our privacy practices, please see our <a href={"/privacy"} target={"_blank"}>Privacy Policy</a>.</p>
                        </div>
                        <div className="content__gdprLegal mt-2">
                            <p>
                                We use Mailchimp as our marketing platform. By clicking below to subscribe, you acknowledge that your information will be transferred to Mailchimp for processing.
                                <a href="https://mailchimp.com/legal/terms"> Learn more</a> about Mailchimp's privacy practices.
                            </p>
                        </div>
                    </div>
                    <div id="mce-responses" className="clear">
                        <div className="response" id="mce-error-response" style={{display: 'none'}}></div>
                        <div className="response" id="mce-success-response" style={{display: 'none'}}></div>
                    </div>
                    <div aria-hidden="true" style={{position: 'absolute', left: '-5000px'}}>
                        <input
                            type="text"
                            name="b_241faa8632901abf0f0fea122_375c85b106"
                            tabIndex={-1}
                            defaultValue=""
                        />
                    </div>
                    <div className="clear">
                        <input
                            type="submit"
                            name="subscribe"
                            id="mc-embedded-subscribe"
                            className={`
                                                        inline-block w-auto text-center no-underline
                                                        px-6 py-2
                                                        text-xl
                                                        md:text-2xl
                                                        leading-5 md:leading-6 lg:leading-7
                                                        !rounded-xl !border-0
                                                        shadow-[0_4px_4px_rgba(0,0,0,0.25)]
                                                        bg-gradient-to-b from-[#FFC107] via-[#F17404] to-[#E74102]
                                                        hover:brightness-110 hover:saturate-110
                                                        focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-[#F17404]/50
                                                        active:translate-y-px
                                                        !ml-0
                                                        `}
                            value={buttonText}
                        />
                    </div>
                </div>
            </form>
        </div>
    </Container>
        ;
}

const Container = styled.div`

    /* Mailchimp form overrides - golden glass card style */

    #mc_embed_signup {
        border-radius: 16.324px;
        border: 1.632px solid rgba(255, 255, 255, 0.60);
        background: rgba(255, 193, 7, 0.25);
        backdrop-filter: blur(25px);
        clear: left;
        font: 14px Helvetica, Arial, sans-serif;
        width: 100%;
        max-width: 600px;
        padding: 20px;
        color: white;
    }

    #mc-embedded-subscribe-form input[type=checkbox] {
        display: inline;
        width: auto;
        margin-right: 10px;
    }

    #mergeRow-gdpr {
        margin-top: 20px;
    }

    #mergeRow-gdpr fieldset label {
        font-weight: normal;
    }

    #mc-embedded-subscribe-form .mc_fieldset {
        border: none;
        min-height: 0px;
        padding-bottom: 0px;
    }

    /* Style the submit button to match your theme */

    #mc-embedded-subscribe {
        //background-color: #ffc107;
        //color: #000;
        //font-weight: bold;
        //padding: 12px 24px;
        //border: none;
        //border-radius: 8px;
        //cursor: pointer;
        //transition: all 0.3s ease;
    }

    #mc-embedded-subscribe:hover {
        background-color: #ffb300;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
`;


//// Reference Form: Email & UTMs
// ```
// <div id="mc_embed_shell">
//     <link href="//cdn-images.mailchimp.com/embedcode/classic-061523.css" rel="stylesheet" type="text/css"/>
//     <style type="text/css">
//         #mc_embed_signup{background:#fff; false;clear:left; font:14px Helvetica,Arial,sans-serif; width: 600px;}
//         /* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
//         We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
//     </style>
//     <style type="text/css">
//         #mc-embedded-subscribe-form input[type=checkbox]{display: inline; width: auto;margin-right: 10px;}
//         #mergeRow-gdpr {margin - top: 20px;}
//         #mergeRow-gdpr fieldset label {font - weight: normal;}
//         #mc-embedded-subscribe-form .mc_fieldset{border:none;min-height: 0px;padding-bottom:0px;}
//     </style>
//     <div id="mc_embed_signup">
//         <form action="https://beunbreakable.us10.list-manage.com/subscribe/post?u=241faa8632901abf0f0fea122&amp;id=375c85b106&amp;v_id=5780&amp;f_id=00e94ae4f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank">
//             <div id="mc_embed_signup_scroll"><h2>Subscribe</h2>
//                 <div className="indicates-required"><span className="asterisk">*</span> indicates required</div>
//                 <div className="mc-field-group"><label htmlFor="mce-EMAIL">Email Address <span className="asterisk">*</span></label><input type="email" name="EMAIL" className="required email" id="mce-EMAIL" required="" value=""/></div>
//                 <div className="mc-field-group"><label htmlFor="mce-MMERGE9">UTM_SOURCE </label><input type="text" name="MMERGE9" className=" text" id="mce-MMERGE9" value=""/></div>
//                 <div className="mc-field-group"><label htmlFor="mce-MMERGE10">UTM_MEDIUM </label><input type="text" name="MMERGE10" className=" text" id="mce-MMERGE10" value=""/></div>
//                 <div className="mc-field-group"><label htmlFor="mce-MMERGE11">UTM_CAMPAIGN </label><input type="text" name="MMERGE11" className=" text" id="mce-MMERGE11" value=""/></div>
//                 <div id="mergeRow-gdpr" className="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group">
//                     <div className="content__gdpr"><label>Marketing Permissions</label><p>Please confirm that you are giving us permission to email you with the info and updates you are requesting:</p>
//                         <fieldset className="mc_fieldset gdprRequired mc-field-group" name="interestgroup_field"><label className="checkbox subfield" htmlFor="gdpr60696"><input type="checkbox" id="gdpr_60696" name="gdpr[60696]" className="gdpr" value="Y"/><span>Email</span></label></fieldset>
//                         <p>You can unsubscribe at any time by clicking the link in the footer of our emails. For information about our privacy practices, please visit our website.</p></div>
//                     <div className="content__gdprLegal"><p>We use Mailchimp as our marketing platform. By clicking below to subscribe, you acknowledge that your information will be transferred to Mailchimp for processing. <a href="https://mailchimp.com/legal/terms">Learn more</a> about Mailchimp's privacy practices.</p></div>
//                 </div>
//                 <div id="mce-responses" className="clear">
//                     <div className="response" id="mce-error-response" style="display: none;"></div>
//                     <div className="response" id="mce-success-response" style="display: none;"></div>
//                 </div>
//                 <div aria-hidden="true" style="position: absolute; left: -5000px;"><input type="text" name="b_241faa8632901abf0f0fea122_375c85b106" tabIndex="-1" value=""/></div>
//                 <div className="clear"><input type="submit" name="subscribe" id="mc-embedded-subscribe" className="button" value="Subscribe"/></div>
//             </div>
//         </form>
//     </div>
//     <script type="text/javascript" src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"></script>
//     <script type="text/javascript">(function ($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[9]='MMERGE9';ftypes[9]='text';fnames[10]='MMERGE10';ftypes[10]='text';fnames[11]='MMERGE11';ftypes[11]='text';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';fnames[6]='SUBINTENT';ftypes[6]='radio';fnames[5]='USERPLAN';ftypes[5]='dropdown';fnames[7]='MMERGE7';ftypes[7]='dropdown';fnames[8]='KS_PLEDGE';ftypes[8]='number';}(jQuery)
//     )
//     ;var $mcj = jQuery.noConflict(true);</script>
// </div>
// ```